<template>
    <div class="page page-test page-testresult">
        <div class="result__item">
            <div class="result__item-leftside">
                <router-link to="/rating">
                    {{ !Helpers.isTouch() ? 'Посмотреть рейтинг' : 'Рейтинг' }}
                </router-link>
                <router-link to="/">
                    На главную
                </router-link>
            </div>
            <div class="result__item-content">
                <div class="content-main">
                    вы прошли тест за&nbsp;<span class="minutes">{{ formatVal(testResult.time.min)
                    }}:{{ formatVal(testResult.time.sec) }}</span> минут<br>
                    и&nbsp;набрали <span class="balls">{{ testResult.score }}</span> баллов.<br class="mobile">
                </div>
                <div class="content-social">
                    <div class="content-social__text">
                        Поделитесь результатом:
                    </div>
                    <ul class="social-list" >
                        <li class="social-item">
                            <a @click="share('tw')" href="#" class="social-link tw">
                                <tw></tw>
                            </a>
                        </li>
                        <li class="social-item">
                            <a @click="share('fb')" href="#" class="social-link fb">
                                <fb></fb>
                            </a>
                        </li>
                        <li class="social-item">
                            <a @click="share('vk')" href="#" class="social-link vk">
                                <vk></vk>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {TweenMax} from 'gsap'
    import Helpers from '@/tools/Helpers'
    import tw from '@/assets/svg/tw.svg';
    import fb from '@/assets/svg/fb.svg';
    import vk from '@/assets/svg/vk.svg';
    import social from '@/components/common/Socials';

    export default {
        name: 'TestResult',
        data() {
            return {
                url: encodeURIComponent(window.location.protocol + '//' + window.location.host),
                Helpers
            }
        },
        computed: {
            testResult() {
                return this.$store.getters['GET_TEST_RESULT']
            },
			isGuest() {
				return this.$store.getters['isGuest'];
			},
        },
        created() {
            if (!this.testResult) {
                this.$router.push('/test');
            }
        },
        methods: {
			authPopup() {
				this.$store.commit('SET_POPUP', {name: 'Auth'});

			},
			shareVideo() {
			    if(this.isGuest){
			    	this.authPopup()
                }else {
					this.$router.push('/profile')
                }
            },
            formatVal(val) {
                return (parseInt(val) < 10) ? '0' + parseInt(val) : parseInt(val);
            },
            share(sn) {
                let url = this.url + '/share/1';
                Helpers.share(sn, url);
                Helpers.ga().send('click','share test', sn)
            },
			socialAuth(sn) {
				this.$store.dispatch('socialAuth', sn).then(
					() => {
						this.$store.commit('SET_POPUP', false);
						this.$router.push('/profile')
					}
				)
			}
        },
        components: {
            tw,
            fb,
            vk,
            social
        }
    }
</script>



// WEBPACK FOOTER //
// TestResult.vue?1be13028